module.exports = __webpack_public_path__ + "static/media/logo-mwe.022a0430.png";